// Single source of truth for permission codes on the frontend.
// Mirrors backend `id.co.gspe.authserver.service.Permissions`. Keep in sync.
export const PERMISSIONS = {
  USERS_VIEW: "can_view_users",
  USERS_CREATE: "can_create_users",
  USERS_EDIT: "can_edit_users",
  USERS_DELETE: "can_delete_users",
  USERS_IMPORT: "can_import_users",
  USERS_SYNC: "can_sync_users",
  APPS_VIEW: "can_view_apps",
  APPS_MANAGE: "can_manage_apps",
  DEPARTMENTS_VIEW: "can_view_departments",
  DEPARTMENTS_MANAGE: "can_manage_departments",
  DEPARTMENT_GROUPS_VIEW: "can_view_department_groups",
  DEPARTMENT_GROUPS_MANAGE: "can_manage_department_groups",
  ROLES_MANAGE: "can_manage_roles",
  HIERARCHY_VIEW: "can_view_hierarchy",
  HIERARCHY_MANAGE: "can_manage_hierarchy",
  SHIFTS_VIEW: "can_view_shifts",
  SHIFTS_MANAGE: "can_manage_shifts",
  SHIFT_TEMPLATES_VIEW: "can_view_shift_templates",
  SHIFT_TEMPLATES_MANAGE: "can_manage_shift_templates",
  COMPANIES_VIEW: "can_view_companies",
  COMPANIES_MANAGE: "can_manage_companies",
  PPH21_VIEW: "can_view_pph21",
  PPH21_MANAGE: "can_manage_pph21",
  ATTENDANCE_VIEW: "can_view_attendance",
  ATTENDANCE_MANAGE: "can_manage_attendance",
  WA_LOGS_VIEW: "can_view_wa_logs",
  WA_BLACKLIST_VIEW: "can_view_wa_blacklist",
  WA_BLACKLIST_MANAGE: "can_manage_wa_blacklist",
  CONFIGURATION_VIEW: "can_view_configuration",
  CONFIGURATION_MANAGE: "can_manage_configuration",
} as const;

export type PermissionCode = typeof PERMISSIONS[keyof typeof PERMISSIONS];

interface RouteLike {
  permission?: string;
}

// Shared route-gate predicate used by both the router (Dashboard) and the menu
// (Sidebar) so page access and menu visibility can never drift apart.
export const canAccessRoute = (
  permissions: string[] | undefined,
  route: RouteLike
): boolean => !route.permission || (permissions ?? []).includes(route.permission);
